import { render, staticRenderFns } from "./AllContacts.vue?vue&type=template&id=a985b6f8&scoped=true&"
import script from "./AllContacts.vue?vue&type=script&lang=js&"
export * from "./AllContacts.vue?vue&type=script&lang=js&"
import style0 from "./AllContacts.vue?vue&type=style&index=0&id=a985b6f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a985b6f8",
  null
  
)

export default component.exports